var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"works"},[_c('LeftMenu',{attrs:{"current":"songManage"}}),_c('div',{staticClass:"main",class:{songManage:_vm.$route.meta.active}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }